var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"insightChartBar",staticClass:"istStackChart",attrs:{"height":500,"options":_vm.chartOptionsBar,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }